import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=e95ab65a&scoped=true&"
import script from "./BlogDetails.vue?vue&type=script&lang=ts&"
export * from "./BlogDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BlogDetails.vue?vue&type=style&index=0&id=e95ab65a&scoped=true&lang=css&"
import style1 from "./BlogDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95ab65a",
  null
  
)

export default component.exports